import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Layout as AntLayout, Dropdown, Avatar, Badge, Space, Button, Tooltip, Input } from 'antd';
import type { MenuProps } from 'antd';
import {
  UserOutlined,
  DownOutlined,
  BellOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
import '../css/Layout.css';

interface LayoutProps {
  onLogout: () => void;
}

const { Header, Content } = AntLayout;

// User menu items for dropdown
const userMenu = (onLogout: () => void): MenuProps['items'] => [
  {
    key: 'profile',
    icon: <UserOutlined />,
    label: 'Profile Settings'
  },
  {
    type: 'divider'
  },
  {
    key: 'logout',
    label: 'Logout',
    danger: true,
    onClick: onLogout
  }
];

const Layout: React.FC<LayoutProps> = ({ onLogout }) => {
  const [notifications] = useState(2);
  const [searchText, setSearchText] = useState('');

  return (
    <div className='layout' style={{ height: '100vh', display: 'flex' }}>
      <Sidebar />
      <div className='layout-main' style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Header className='layout-header' style={{ flexShrink: 0, backgroundColor: 'rgb(1,134,158)' }}>
          <div className='header-left'>
          </div>
          <div className='header-right'>
            <Space size={16}>
              <Tooltip title="Help">
                <Button type="text" icon={<QuestionCircleOutlined />} />
              </Tooltip>
              <Tooltip title="Settings">
                <Button type="text" icon={<SettingOutlined />} />
              </Tooltip>
              <Tooltip title="Notifications">
                <Badge count={notifications} offset={[-5, 5]}>
                  <Button type="text" icon={<BellOutlined />} />
                </Badge>
              </Tooltip>
              <Dropdown menu={{ items: userMenu(onLogout) }} trigger={['click']}>
                <div className='user-info'>
                  <Avatar
                    icon={<UserOutlined />}
                    style={{ backgroundColor: '#1890ff' }}
                  />
                  <span className='username'>Admin</span>
                  <DownOutlined />
                </div>
              </Dropdown>
            </Space>
          </div>
        </Header>
        <Content className='layout-content' style={{
          flex: 1,
          overflow: 'auto',
          padding: '24px'
        }}>
          <Outlet />
        </Content>
      </div>
    </div>
  );
};

export default Layout;
